<template>
  <v-form
  class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">List available Profiles</h3>
    <p class="text-caption mb-4">Lista los perfiles disponibles en Alison Desktop.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="validate">
        Get Profile list >>
      </v-btn>
    </div>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <vue-json-pretty :rootPath="'res'" :data=this.response> </vue-json-pretty>
      </v-col>
    </v-row>

  </v-form>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default  {
    components: {
      VueJsonPretty,
    },
    data: () => ({
      profiles: null,
      valid: true,
      response: "",
    }),
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      validate () {
        console.log("validate ref:", this.$refs)
        if (this.$refs.form.validate()) {
          this.listProfiles()
        }
      },
      listProfiles() {
        alisonJS.listProfiles().then((list) => {
          console.log(list)
              this.setColor('success')
              this.setSnack('Profiles obtained successfully')
              this.$emit('setProfiles',list.profiles);
            this.response = list;
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = e;
          })
      }
    },
  }
</script>
